package com.fireavert.invite.data_models.exceptions

class PasswordMinimumLengthException: Exception("Passwords must be at least 5 characters") {
}